import {
  AfterViewInit,
  Component,
  Input,
  ViewChild,
  HostListener,
  EventEmitter,
  Output,
  OnInit,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { DatePipe } from "@angular/common";
import { GlobalVariable } from "app/global/global";
import { environment } from "environments/environment.prod";
import { ActivatedRoute, Router } from "@angular/router";
import { ShowImagenComponent } from "app/shared/show-imagen/show-imagen.component";
import { MatDialog } from "@angular/material/dialog";
import { saveAs } from "file-saver";
import { Medico } from "app/models/medico.interface";
import { EstudioMedicoPacienteService } from "../../../services/estudio-medico-paciente.service";
import { RecetaService, CanalesCompartir } from "../../../services/receta.service";
import { OrdenService } from "../../../services/orden.service";
import { ArchivoService } from "../../../services/archivo.service";
import { EstudioMedicoDialogComponent } from "../../estudio-medico-dialog/estudio-medico-dialog.component";
import { CompartirRecetaDialogComponent } from "../../compartir-receta-dialog/compartir-receta-dialog.component";
import { CompartirImagenesDialogComponent } from "../../imagenes/compartir-imagenes-dialog/compartir-imagenes-dialog.component";
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PacienteService } from "../../../services/paciente.service";
import { CatalogoRecetarioService } from "../../../services/catalogo-recetario.service";
import { ObraSocial } from "../../../models/obraSocial.interface";
import { FormControl } from "@angular/forms";
@Component({
  selector: "app-estudios-medicos",
  templateUrl: "./estudios-medicos.component.html",
  styleUrls: ["./estudios-medicos.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)"),
      ),
    ]),
  ],
})
export class EstudiosMedicosComponent implements AfterViewInit, OnInit {
  //
  @Input("cols") cols: any[] = [];
  isOpen = false;
  url: string = GlobalVariable.BASE_API_URL;
  urlXls: string = GlobalVariable.BASE_API_URL + "storage/images/paciente/";
  dataSource: any;
  sortedData = [];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  idPaciente: string;
  medico: Medico;
  imageData: any;
  paciente: any;
  estudiosMedicosPaciente: any;
  tipoestudios = environment.BASE_TYPEOFESTUDIOS;
  columnsFiles = [
    "fecha",
    "estudio",
    "tipo",
    "estado",
    "medico",
    "centromedico",
    "acciones",
  ];
  columnsFile = ["fecha", "archivo", "acciones"];
  historialMedico = false;
  @Input() set response(value: any) {
    if (value) {
      this.listarEstudiosMedicos(value);
    }
  }

  @Input() set responseMedico(value: any) {
    if (value) {
      this.medico = value;
    }
  }

  @Input() formData = null;
  @Input() recetarioStatus: any = null;
  @Output() listar: EventEmitter<boolean> = new EventEmitter<boolean>();

  editandoDatosPaciente = false;
  editName = "";
  editSurname = "";
  editDocumento = "";
  editGender = "";
  editFechaNacimiento = "";
  editObraSocial: number = 0;
  obrasSociales: ObraSocial[] = [];
  filtroObrasSociales: ObraSocial[] = [];
  obraSocialBuscador: FormControl = new FormControl();
  guardandoDatos = false;
  canalesCompartir: CanalesCompartir = {};

  //
  constructor(
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private actRoute: ActivatedRoute,
    private router: Router,
    private estudioMedicoPacienteService: EstudioMedicoPacienteService,
    private recetaService: RecetaService,
    private ordenService: OrdenService,
    private archivoService: ArchivoService,
    private snackBar: MatSnackBar,
    private pacienteService: PacienteService,
    private catalogoRecetarioService: CatalogoRecetarioService,
  ) {
    this.idPaciente = this.actRoute.snapshot.paramMap.get("id");
    if (window.innerWidth > 900) {
      this.historialMedico = false;
    } else {
      this.historialMedico = true;
    }
  }

  ngOnInit(): void {
    this.recetaService.getCanalesCompartir().subscribe({
      next: (canales) => (this.canalesCompartir = canales),
    });
  }

  get puedeCompartir(): boolean {
    return !!this.canalesCompartir.whatsapp || !!this.canalesCompartir.email;
  }

  //
  ngAfterViewInit() {}

  //
  @HostListener("window:resize", ["$event"]) onResize(event) {
    if (event.target.innerWidth > 900) {
      this.historialMedico = false;
    } else if (event.target.innerWidth <= 900) {
      this.historialMedico = true;
    }
  }

  //
  listarEstudiosMedicos(data: any) {
    this.paciente = data.paciente;
    this.estudiosMedicosPaciente = data.estudiosMedicosPaciente;
    this.estudiosMedicosPaciente.forEach((element) => {
      element.fechaOriginal = element.fecha;
      let date = new Date(element.fecha);
      element.fecha = this.datePipe.transform(date, "dd/MM/yyyy");
      element.imagenCM =
        this.url + "storage/images/centro-medico/" + element.imagenCM;
    });
    this.estudiosMedicosPaciente.sort((a, b) => {
      return (
        new Date(b.fechaOriginal).getTime() -
        new Date(a.fechaOriginal).getTime()
      );
    });
    this.dataSource = new MatTableDataSource(this.estudiosMedicosPaciente);
    this.dataSource.sort = this.sort;
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
    });
  }

  //
  async mostrarImagen(imagen: any) {
    const dialogRef = this.dialog.open(ShowImagenComponent, {
      width: "95%",
      height: "95%",
      data: imagen,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  //
  descargarImage(imagen: any) {
    let id = imagen.imagen.idPaciente;
    fetch(this.urlXls + id + "/" + imagen.id + "/" + imagen.imagen.nombre).then(
      function (response) {
        response.blob().then(function (blob) {
          let file = new File([blob], imagen.imagen.nombre, {
            type: "application/jpeg",
          });
          saveAs(file);
        });
      },
    );
  }

  //
  descargarPdf(imagen: any) {
    let id = imagen.imagen.idPaciente;
    fetch(this.urlXls + id + "/" + imagen.id + "/" + imagen.imagen.nombre).then(
      function (response) {
        response.blob().then(function (blob) {
          let file = new File([blob], imagen.imagen.nombre, {
            type: "application/pdf",
          });
          saveAs(file);
        });
      },
    );
  }

  //
  descargarExcel(imagen: any) {
    let id = imagen.imagen.idPaciente;
    fetch(this.urlXls + id + "/" + imagen.id + "/" + imagen.imagen.nombre).then(
      function (response) {
        response.blob().then(function (blob) {
          let file = new File([blob], imagen.imagen.nombre, {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(file);
        });
      },
    );
  }

  //
  cargarImagen(event) {
    (event.target as HTMLImageElement).style.display = "flex";
  }

  //
  select(expandedElement, element) {
    //this.router.navigate(['/seccion-medico/estudios-medicos/detalle',element.id]);
  }

  public editarEstudio(ruta: string[]) {
    this.router.navigate(ruta);
  }

  get recetaDeshabilitada(): boolean {
    if (this.paciente && !this.paciente.datos_receta_completos) return true;
    if (!this.recetarioStatus) return true;
    if (!this.recetarioStatus.habilitado) return true;
    if (this.recetarioStatus.datosFaltantes?.length > 0) return true;
    if (!this.recetarioStatus.activeInApi) return true;
    return false;
  }

  get recetaTooltip(): string {
    if (this.paciente && !this.paciente.datos_receta_completos) {
      return "Completá los datos del paciente para emitir recetas";
    }
    if (!this.recetarioStatus || !this.recetarioStatus.habilitado) {
      return "Tu plan actual no incluye recetas digitales";
    }
    if (this.recetarioStatus.datosFaltantes?.length > 0) {
      return "Completá tus datos de perfil para emitir recetas";
    }
    if (!this.recetarioStatus.activeInApi) {
      return "Tu plan actual no incluye recetas digitales";
    }
    return "";
  }

  get ordenDeshabilitada(): boolean {
    if (this.paciente && !this.paciente.datos_receta_completos) return true;
    if (!this.recetarioStatus) return true;
    if (!this.recetarioStatus.habilitado) return true;
    if (this.recetarioStatus.datosFaltantes?.length > 0) return true;
    if (!this.recetarioStatus.activeInApi) return true;
    return false;
  }

  get ordenTooltip(): string {
    if (this.paciente && !this.paciente.datos_receta_completos) {
      return "Completá los datos del paciente para emitir órdenes";
    }
    if (!this.recetarioStatus || !this.recetarioStatus.habilitado) {
      return "Tu plan actual no incluye órdenes digitales";
    }
    if (this.recetarioStatus.datosFaltantes?.length > 0) {
      return "Completá tus datos de perfil para emitir órdenes";
    }
    if (!this.recetarioStatus.activeInApi) {
      return "Tu plan actual no incluye órdenes digitales";
    }
    return "";
  }

  get camposFaltantes(): string[] {
    return this.paciente?.datos_receta_faltantes || [];
  }

  campoFaltante(campo: string): boolean {
    return this.camposFaltantes.includes(campo);
  }

  get formDatosValido(): boolean {
    const f = this.camposFaltantes;
    if (f.includes("name") && !this.editName.trim()) return false;
    if (f.includes("surname") && !this.editSurname.trim()) return false;
    if (f.includes("numeroDocumento") && !this.editDocumento.trim()) return false;
    if (f.includes("gender") && !this.editGender) return false;
    if (f.includes("fechaNacimiento") && !this.editFechaNacimiento) return false;
    if (f.includes("obraSocial") && this.editObraSocial === undefined) return false;
    return true;
  }

  mostrarFormDatosPaciente(): void {
    this.editandoDatosPaciente = true;
    this.editName = this.paciente?.name || "";
    this.editSurname = this.paciente?.surname || "";
    this.editDocumento = this.paciente?.numeroDocumento || "";
    this.editGender = this.paciente?.gender || "";
    this.editFechaNacimiento = this.paciente?.fechaNacimiento || "";
    this.editObraSocial = this.paciente?.obraSocial ? Number(this.paciente.obraSocial) : 0;

    if (this.campoFaltante("obraSocial") && this.obrasSociales.length === 0) {
      this.catalogoRecetarioService.getObrasSociales().subscribe((data) => {
        this.obrasSociales = (data || []).sort((a, b) => a.nombre.localeCompare(b.nombre));
        this.filtroObrasSociales = [...this.obrasSociales];
      });
    }
  }

  guardarDatosPaciente(): void {
    if (!this.paciente) return;
    if (!this.formDatosValido) {
      const f = this.camposFaltantes;
      const etiquetas: { [campo: string]: string } = {
        name: "Nombre",
        surname: "Apellido",
        numeroDocumento: "Nro. Documento",
        gender: "Género",
        fechaNacimiento: "Fecha de nacimiento",
        obraSocial: "Obra social",
      };
      const faltan = [
        f.includes("name") && !this.editName.trim() && etiquetas.name,
        f.includes("surname") && !this.editSurname.trim() && etiquetas.surname,
        f.includes("numeroDocumento") && !this.editDocumento.trim() && etiquetas.numeroDocumento,
        f.includes("gender") && !this.editGender && etiquetas.gender,
        f.includes("fechaNacimiento") && !this.editFechaNacimiento && etiquetas.fechaNacimiento,
        f.includes("obraSocial") && this.editObraSocial === undefined && etiquetas.obraSocial,
      ].filter(Boolean);
      this.snackBar.open(
        "Completá los campos obligatorios: " + faltan.join(", "),
        "OK",
        { duration: 3000 },
      );
      return;
    }
    this.guardandoDatos = true;

    const data: Record<string, any> = {};
    if (this.campoFaltante("name")) data.name = this.editName.trim();
    if (this.campoFaltante("surname")) data.surname = this.editSurname.trim();
    if (this.campoFaltante("numeroDocumento")) data.numeroDocumento = this.editDocumento.trim();
    if (this.campoFaltante("gender")) data.gender = this.editGender;
    if (this.campoFaltante("fechaNacimiento")) data.fechaNacimiento = this.editFechaNacimiento;
    if (this.campoFaltante("obraSocial")) data.obraSocial = this.editObraSocial;

    this.pacienteService.actualizarDatosBasicos(this.paciente.id, data).subscribe({
      next: (res) => {
        Object.assign(this.paciente, data);
        this.paciente.datos_receta_completos = res.datos_receta_completos ?? true;
        this.paciente.datos_receta_faltantes = res.datos_receta_faltantes ?? [];
        this.editandoDatosPaciente = false;
        this.guardandoDatos = false;
        this.snackBar.open("Datos del paciente actualizados", "OK", { duration: 3000 });
      },
      error: () => {
        this.snackBar.open("Error al guardar los datos del paciente", "OK", { duration: 3000 });
        this.guardandoDatos = false;
      },
    });
  }

  filtrarObraSocial(): void {
    const texto = this.obraSocialBuscador.value || "";
    this.filtroObrasSociales = this.obrasSociales.filter((obra) =>
      obra.nombre.toUpperCase().includes(texto.toUpperCase())
    );
  }

  openFormDialog(tipo: "estudio" | "receta" | "orden" | "odontograma") {
    const formData = { ...(this.formData || {}), medicoId: this.medico?.id };
    const dialogRef = this.dialog.open(EstudioMedicoDialogComponent, {
      panelClass: "estudio-medico-dialog",
      width: "900px",
      maxWidth: "95vw",
      data: { formData, tipo },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.listar.emit(true);
      }
    });
  }

  compartirReceta(element: any): void {
    this.dialog.open(CompartirRecetaDialogComponent, {
      width: "450px",
      data: {
        recetas: [
          {
            id: element.id,
            external_prescription_id: element.external_prescription_id,
            external_code: element.external_code,
            medicamentos: element.medicamentos || [],
          },
        ],
        paciente: {
          email: this.paciente?.email || "",
          celular:
            (this.paciente?.celPais || "") +
            (this.paciente?.celCaract || "") +
            (this.paciente?.celNumero || ""),
        },
        canales: this.canalesCompartir,
      },
    });
  }

  anularReceta(element: any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: "receta",
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.recetaService.anular(element.id).subscribe({
          next: () => {
            element.status = "cancelled";
            this.snackBar.open("Receta anulada correctamente", "OK", {
              duration: 3000,
            });
          },
          error: (err) => {
            this.snackBar.open(
              err.error?.error || "Error al anular la receta",
              "OK",
              { duration: 5000 },
            );
          },
        });
      }
    });
  }

  verPdfOrden(element: any): void {
    if (!element.archivos?.length) return;

    const archivo = element.archivos[0];
    this.archivoService
      .getImagenProtegida(
        archivo.idPaciente,
        archivo.idEstudioMedico,
        archivo.nombre,
      )
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);
          window.open(url, "_blank");
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        },
        error: () => {
          this.snackBar.open("Error al obtener el PDF de la orden", "OK", {
            duration: 3000,
          });
        },
      });
  }

  compartirOrden(element: any): void {
    this.dialog.open(CompartirRecetaDialogComponent, {
      width: "450px",
      data: {
        recetas: [
          {
            id: element.id,
            external_prescription_id: element.external_order_id,
            external_code: "",
            medicamentos: [],
          },
        ],
        paciente: {
          email: this.paciente?.email || "",
          celular:
            (this.paciente?.celPais || "") +
            (this.paciente?.celCaract || "") +
            (this.paciente?.celNumero || ""),
        },
        canales: this.canalesCompartir,
      },
    });
  }

  compartirImagenes(element: any): void {
    this.dialog.open(CompartirImagenesDialogComponent, {
      width: "450px",
      data: { idEstudio: element.id, email: this.paciente?.email },
    });
  }

  verPdfReceta(element: any): void {
    if (!element.archivos?.length) return;

    const archivo = element.archivos[0];
    this.archivoService
      .getImagenProtegida(
        archivo.idPaciente,
        archivo.idEstudioMedico,
        archivo.nombre,
      )
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);
          window.open(url, "_blank");
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        },
        error: () => {
          this.snackBar.open("Error al obtener el PDF de la receta", "OK", {
            duration: 3000,
          });
        },
      });
  }

  descargarPDFEstudioMedico(estudioMedicoPaciente) {
    const em = {
      ...estudioMedicoPaciente,
      nombreP: (
        (this.paciente.name || "") +
        " " +
        (this.paciente.surname || "")
      ).trim(),
    };

    this.estudioMedicoPacienteService.descargarPDFEstudioMedico(
      em,
      em.archivos,
    );
  }
}
